import { createReducer } from '@reduxjs/toolkit'
import { DictT, TourModelT } from 'types/model'
import { clear, logout, receiveTourModels } from 'model/actions'

const initialState = null as DictT<TourModelT> | null

const reducer = createReducer(initialState, builder => {
  builder
    .addCase(receiveTourModels, (state, action) => action.payload)
    .addCase(clear, () => initialState)
    .addCase(logout, () => initialState)
})

export default reducer
